import { TableColumn } from 'react-data-table-component';
import { useSelector } from 'react-redux';
import { RootState } from 'client/_redux/reducers';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import React, { useRef, useCallback } from 'react';
import { CRUDDataTableHandle } from 'dashboard/containers/CRUDDataTable';
import { useTableColumnsWithActions } from 'dashboard/containers/CRUDDataTable/useTableColumnsWithActions';
import { useNavigate } from 'react-router-dom';
import { IUserWithInvoiceData } from 'dashboard/_redux/reducers/invoices';

export const useInvoiceList = () => {
  const [t] = useTranslation();
  const dataTableRef = useRef<CRUDDataTableHandle>(null);
  const navigate = useNavigate();

  const { usersWithInvoices, loaded } = useSelector(
    (state: RootState) => state.dashboardInvoices,
  );

  const onPressShow = useCallback(
    (item: IUserWithInvoiceData) => {
      navigate(`/dashboard/invoices/${item._id}`);
    },
    [navigate],
  );

  const tableCols: TableColumn<IUserWithInvoiceData>[] = [
    {
      name: t('dashboard.invoicesPage.username'),
      selector: (e) => e.username,
      sortable: true,
      center: true,
      sortfield: 'username',
    },
    {
      name: t('dashboard.invoicesPage.email'),
      selector: (e) => e.email,
      sortable: true,
      center: true,
      sortfield: 'email',
    },
    {
      name: t('dashboard.invoicesPage.totalTransactions'),
      selector: (e) => e.totalTransactions,
      sortable: true,
      center: true,
      sortfield: 'totalTransactions',
    },
    {
      name: t('dashboard.invoicesPage.totalAmount'),
      selector: (e) => `${e.totalAmount.toFixed(2)} €`,
      sortable: true,
      center: true,
      sortfield: 'totalAmount',
    },
    {
      name: t('dashboard.invoicesPage.totalInvoices'),
      selector: (e) => e.totalInvoices,
      sortable: true,
      center: true,
      sortfield: 'totalInvoices',
    },
    {
      name: t('dashboard.invoicesPage.lastTransaction'),
      selector: (e) =>
        e.lastTransaction ? format(new Date(e.lastTransaction), 'dd-MM-yyyy') : '',
      sortable: true,
      center: true,
      sortfield: 'lastTransaction',
    },
  ];

  const columns = useTableColumnsWithActions({
    columns: tableCols,
    buttons: [
      {
        fn: onPressShow,
        title: t('dashboard.invoicesPage.viewInvoices'),
        className: 'btn btn-dark btn-xs m-1',
      },
    ],
  });

  return {
    usersWithInvoices,
    loaded,
    columns,
    dataTableRef,
  };
};
